import React from 'react';
import { renderValue } from '../RenderValue';

export default function PricingLayout({ pricing, values }: { pricing: any; values: any[] }) {

  return (
    <>
      {pricing && (
        <>
          {[
            // pricing?.somos_code?.[0] && ['CÓDIGO SOMOS', pricing.somos_code[0]],
            ['PLACA', pricing.plate],
            ['CHASSI', pricing.chassi],
            ['FABRICANTE', pricing.fabricator],
            ['PRODUTO', pricing.product],
            ['MODELO', pricing.brand_model],
            ['ANO', pricing.year_fabrication],
            ['EIXOS', pricing.axis],
            ['TIPO DE VEÍCULO', pricing.type_vehicle],
            ['FABRICADO NA REGIÃO', pricing.region],
            ['FABRICADO NA UF', pricing.state],
            ['FABRICADO NA CIDADE', pricing.city],
          ]
            .filter(Boolean)
            .map(([label, value], i) => (
              <tr key={i}>
                <td className="no-border">{label}</td>
                <td>{value ?? '-'}</td>
              </tr>
            ))}
        </>
      )}
      {values.length > 0 &&
        <tr>
          <td className="price" style={{ backgroundColor: '#006991', color: 'white', textAlign: 'center' }} colSpan={2}>
            {values[0]?.type === "5" ? 'PREÇOS FIPE' :'PREÇOS POSSÍVEIS NA TABELA SOMOS'}
          </td>
        </tr>
      
      }
      {values.map((item, index) => (
        <React.Fragment key={index}>{renderValue(item, false, pricing, values)}</React.Fragment>
      ))}
    </>
  );
}